import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";

const FeaturesSection = () => {
  const [featuresData, setFeaturesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturesData = async () => {
      try {
        const response = await fetch("https://ecom-22-fe6311cae608.herokuapp.com/api/features-section");
        const data = await response.json();
        
        if (data.success) {
          setFeaturesData(data.data);
        } else {
          setError(data.message || "Failed to fetch features section data");
        }
      } catch (err) {
        setError("Network error. Please try again later.");
        console.error("Error fetching features section:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturesData();
  }, []);

  if (loading) {
    return (
      <section className="about-area about-area-v2 pt-130">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden"></span>
                </Spinner>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="about-area about-area-v2 pt-130">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <Alert variant="danger">{error}</Alert>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!featuresData || !featuresData.isActive) {
    return null; // Don't render if data is not available or section is inactive
  }

  return (
    <>
      <section className="about-area about-area-v2 pt-130">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="img-holder mb-50 wow fadeInLeft">
                <div className="shape shape-one animate-float-y">
                  <span>
                    <img src="/assets/images/shape/shape-5.png" alt="" />
                  </span>
                </div>
                <img src={featuresData.imageUrl} alt="" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="text-wrapper mb-50 wow fadeInRight">
                <div className="section-title mb-25">
                  <h2>{featuresData.title}</h2>
                  <p className="blue-dark">
                    {featuresData.subtitle}
                  </p>
                </div>
                <p>
                  {featuresData.description}
                </p>
                <ul className="list-style-one mb-40">
                  {featuresData.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
                <Link to={featuresData.buttonLink} className="main-btn bordered-btn btn-blue">
                  {featuresData.buttonText}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeaturesSection;